export default {
  "content": "<rect width=\"88\" height=\"88\" rx=\"44\" fill=\"#1D1D1B\"/><path d=\"M32.677 38.489A16.07 16.07 0 0128 28a15.976 15.976 0 0110.453 4.693 16.08 16.08 0 014.677 10.489 15.976 15.976 0 01-10.453-4.693zm22.646 0a15.976 15.976 0 01-10.453 4.693 16.08 16.08 0 014.677-10.49A15.976 15.976 0 0160 28a16.07 16.07 0 01-4.677 10.489zm0 11.022A16.07 16.07 0 0160 60a15.976 15.976 0 01-10.453-4.693 16.08 16.08 0 01-4.677-10.489 15.976 15.976 0 0110.453 4.693zm-22.646 0c2.78-2.801 6.56-4.475 10.508-4.695-.214 3.95-1.934 7.686-4.732 10.491A15.976 15.976 0 0128 60a16.07 16.07 0 014.677-10.489z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "88",
    "height": "88",
    "viewBox": "0 0 88 88",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};